<template>
	<div id="app">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'app',
	components: {
        
	}
}

</script>
<style>
    @import "/static/font/iconfont.css";
    *{
        padding: 0;
        margin: 0;
    }
    *::-webkit-scrollbar{
        width:5px;
        height:5px;
    }
    *::-webkit-scrollbar-track{
        background: #eff1f6;
        border-radius:2px;
    }
    *::-webkit-scrollbar-thumb{
        background: #c5cdda;
        border-radius:2px;
    }
    /* //翻页样式修改 */
    .el-pagination{
        margin-top: 10px;
        text-align: right;
    }
    .el-pagination.is-background .btn-next, 
    .el-pagination.is-background .btn-prev, 
    .el-pagination.is-background .el-pager li{
        color: #606266 !important;
        background-color: #fff !important;
        border: 1px solid #ddd;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
        border: 1px solid #095b95;
        color: #095b95 !important;
    }
    /* table列表样式 */
    .custom-header-table{
        border: 1px solid #cccccc !important;
    }
    .custom-header-table .el-table__header-wrapper th {
      background-color: #f3f3f3 !important;
      color: #000 !important;
      font-weight: bold !important;
      border-color: #ccc;
    }
    .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
      border-color: #ccc !important;
    }
    .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{
        background-color: #f3f3f3 !important;
    }
    /* input内图标样式修改 */
    .el-input__prefix, .el-input__suffix{
        cursor: pointer;
    }
    /* 按钮样式修改 */
    .el-button--primary:focus, 
    .el-button--primary:hover{
        background: #0b7ccc !important;
    }
    /* 弹窗样式修改 */
    .el-dialog{
        border-radius: 5px !important;
    }
    .el-dialog__header{
        border-bottom: 1px solid #ddd;
    }
    .el-dialog__title{
        font-size: 17px !important;
        font-weight: 700;
    }
    .el-dialog__footer{
        border-top: 1px solid #ddd;
    }
    /* 自定义公共样式 */
    .CommPosFixed{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        background: #fff;
        z-index: 999;
    }
    .NavIcon{
        padding: 0 10px 0 5px;
        border-right: 1px solid #ddd;
        cursor: pointer;
        color: #095b95;
        font-weight: 700;
        font-size: 14px;
    }
    .NavIcon:last-child{
        border-right: 0;
    }
    .el-icon-delete{
        color: #d51938;
    }
    .CommMarRt10{
        margin-right: 10px;
        cursor: pointer;
    }
    .Red{
        color: #d51938;
    }
    .HeaderTop{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .HeaderTab{
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }
    .SearchHead,.BtnHead{
        display: flex;
        align-items: center;
        gap: 5px;
    }
    .FlexWrap{
        flex-wrap: wrap;
    }
    .BorderRadius{
        border-radius: 5px !important;
    }
    .BgColor{
        background: #095b95;
    }
    .MarBom{
        margin-bottom: 10px !important;
    }
    .MarBom0{
        margin-bottom: 0 !important;
    }
    .JusCen{
        justify-content: space-between;
    }
    .Line{
        width: 100%;
        height:2px;
        background: #ddd;
        margin: 20px 0;
    }
    .Wid120{
        width: 180px !important;
    }
    /*穿梭框*/
    .el-transfer-panel{
        width: 250px !important;
    }
    /*弹窗公共样式*/
    .DigItem{
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 15px;
    }
    .DigItem.NoFlex{
        display: block;
    }
    .DigItem:last-child{
        margin-bottom: 0;
    }
    .DigItem .DigItemTit{
        width: 100px;
        text-align: right;
    }
    .DigItem .DigItemWidTit{
        width: 20%;
        text-align: right;
    }
    .DigItem .DigItemWidTit.MarRt10{
        margin-right: 10px;
    }
    .DigItem .Wid{
        flex: 1;
    }
</style>
